import { render, staticRenderFns } from "./notcomplete-beauty-profile.vue?vue&type=template&id=8ef5cd7a&"
import script from "./notcomplete-beauty-profile.vue?vue&type=script&lang=js&"
export * from "./notcomplete-beauty-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports